module.exports = __webpack_public_path__ + "img/tv.2e6acde8.svg";